import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";
import LanguageSelect from "./LanguageSelect";

/**
 * The card the sign-in, forgot-password, reset and verify screens share: the
 * same gradient, language picker and footer links, so they read as one place.
 */
const AuthShell = ({ title, children }) => {
  const { t } = useI18n();

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-500 to-primary-700 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl p-8">
        <div className="flex justify-end -mt-2 mb-2">
          <LanguageSelect />
        </div>

        <div className="text-center mb-6">
          <div className="inline-block p-4 bg-primary-100 rounded-full mb-4">
            <span className="text-5xl">💨</span>
          </div>
          <h1 className="text-2xl font-bold text-gray-800">{title}</h1>
        </div>

        {children}

        <p className="mt-8 text-center text-xs text-gray-500 space-x-3 rtl:space-x-reverse">
          <Link to="/terms" className="hover:underline">
            {t("auth.legal.termsLink")}
          </Link>
          <span aria-hidden="true">·</span>
          <Link to="/privacy" className="hover:underline">
            {t("auth.legal.privacyLink")}
          </Link>
        </p>
      </div>
    </div>
  );
};

export const inputClass =
  "w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all";

export const buttonClass =
  "w-full bg-primary-600 hover:bg-primary-700 text-white font-semibold py-3 rounded-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed shadow-lg hover:shadow-xl";

export default AuthShell;
